import styled, { css } from "styled-components";
import { Atom } from 'AppReact';
import device from 'utils/device';

const template = styled.div`
  ${({ theme, displayState }) => css`
    font-size: 14px;
    line-height: 17px;
    color: ${theme?.colour?.secondary};
    &:hover {
      color: ${theme?.colour?.primary};
    }
    @media ${device.tablet} {
      font-size: ${displayState?.big ? '16px' : '14px'};
    }
  `}
`;

export default Atom({ type: 'label', dataType: 'string', template })